import React, { Component, Fragment } from "react";
/*import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";*/
//import Loader from 'react-loader-spinner';

class Spinner extends Component {
    render() {
        if (this.props.showLoader !== true)
            return <Fragment />;

        return (
            <div className='loader-container'>
                <div className='loader loader-vortex'> </div>
               {/*  <Loader type="BallTriangle" color="#0da9ef" timeout={3000} />*/}
                </div>);

  }
}

export default Spinner;
